import {FormattedMessage, defineMessages, useIntl} from 'react-intl';
import {css, view, Spinner} from '@sail/ui/deprecated';

const messages = defineMessages({
  verificationCodesTitle: {
    id: 'conversations_ui.rac.confirmation.verificationCodesTitle',
    description: 'Title for request a call verification codes',
    defaultMessage: 'Security codes',
  },
  verificationCodesAgentInstruction: {
    id: 'conversations_ui.rac.confirmation.verificationCodesAgentInstruction',
    description:
      'Support verification code instruction for user to receive a code from the phone support agent',
    defaultMessage:
      'For your security, your support agent will provide you with the following code to verify their identity:',
  },
  verificationCodesUserInstruction: {
    id: 'conversations_ui.rac.confirmation.verificationCodesUserInstruction',
    description:
      'Support verification code instruction for user to provide the code to the phone support agent',
    defaultMessage:
      "Then, you'll be asked to provide the following code to your agent:",
  },
  verificationCodesRefreshInformation: {
    id: 'conversations_ui.rac.confirmation.verificationCodesRefreshInformation',
    description:
      'Notice to user that the support verification codes refresh on the screen every 5 minutes',
    defaultMessage: 'These codes will refresh every 5 minutes.',
  },
  spinnerLabel: {
    id: 'conversations_ui.rac.confirmation.verificationCodesSpinnerLabel',
    description: 'Aria label text for spinner',
    defaultMessage: 'loading',
  },
});

interface Props {
  verificationCodes?: {
    userCode: string;
    agentCode: string;
  };
  loading?: boolean;
  error?: React.ReactNode;
}

function VerificationCodesBody({
  verificationCodes,
  loading = false,
  error,
}: Props) {
  const intl = useIntl();

  if (error) return <>{error}</>;

  if (
    loading ||
    !verificationCodes?.agentCode ||
    !verificationCodes?.userCode
  ) {
    return <Spinner aria-label={intl.formatMessage(messages.spinnerLabel)} />;
  }

  return (
    <>
      <view.div css={{marginBottom: css.value('16px'), font: 'body'}}>
        <FormattedMessage {...messages.verificationCodesAgentInstruction} />
      </view.div>
      <view.div css={{marginBottom: css.value('16px')}}>
        <view.h3>{verificationCodes.agentCode}</view.h3>
      </view.div>
      <view.div css={{marginBottom: css.value('16px'), font: 'body'}}>
        <FormattedMessage {...messages.verificationCodesUserInstruction} />
      </view.div>
      <view.div css={{marginBottom: css.value('48px')}}>
        <view.h3>{verificationCodes.userCode}</view.h3>
      </view.div>
      <view.div
        css={{
          font: 'body',
          color: 'secondary',
        }}
      >
        <FormattedMessage {...messages.verificationCodesRefreshInformation} />
      </view.div>
    </>
  );
}

export function VerificationCodes(props: Props) {
  return (
    <>
      <view.h4>
        <FormattedMessage {...messages.verificationCodesTitle} />
      </view.h4>
      <VerificationCodesBody {...props} />
    </>
  );
}
